import React, { useCallback, useMemo } from 'react';
import { injectIntl } from 'react-intl';

import {
  Row,
  Col,
  Form,
  InputNumber,
  Select,
  Modal,
} from 'antd';

import { beneficiaryByAreaValidation as validation } from './validation';
import useForm from 'utils/useForm';

import './style.less';


const AREA_OPTIONS = [
  'conciliation',
  'non_sexist_communication',
  'occupational_health',
  'organizational_culture_and_work_environment',
  'other',
  'professional_classification',
  'promotion',
  'remuneration',
  'representation',
  'selection',
  'social_policy',
  'sexism_and_sexual_harassment',
  'training',
  'women_risk_of_exclusion',
  'working_conditions',
];

const BeneficiariesByAreaForm = ({
  intl,
  record,
  index,
  onSave,
  onCancel,
  visible,
}) => {
  const t = intl.messages;
  const defaults = record;
  const validateForm = useMemo(() => validation(t), [ t ]);

  const submitForm = () => {
    const {
      area, male, female,
    } = values;
    onSave(
      'results', 'beneficiaries_by_area', index, {
        area, male, female,
      }
    );
  };

  const {
    values,
    handleChange,
    handleSubmit,
    isDirty,
    errors,
  } = useForm({
    callback: submitForm,
    validate: validateForm,
    defaultValues: defaults,
  });

  const getValue = useCallback(
    (name) => (typeof values[name] === 'undefined' ? defaults[name] : values[name]),
    [values, defaults]
  );
  const showError = useCallback(
    (name) => (!isDirty(name) && errors[name]) || '',
    [isDirty, errors]
  );

  return (
    <Modal
      title={t.equality_evaluation_of_results_beneficiaries_by_area_add}
      visible={visible}
      onOk={handleSubmit}
      onCancel={() => onCancel('results', 'beneficiaries_by_area', index)}
      okText={t.save}
      cancelText={t.cancel}
    >
      <Row>
        <Col span={24} className="form-input-wrapper">
          <Row gutter={10}>
            <Col span={24}>
              <Form.Item
                label={t.equality_evaluation_of_results_area}
                hasFeedback
                validateStatus={ showError('area') ? 'error' : '' }
                help={ showError('area') }
                colon={false}
                required
              >
                <Select
                  name='area'
                  value={getValue('area')}
                  onChange={value => handleChange('area')(value)}
                >
                  {AREA_OPTIONS.sort((a, _) => t['equality_plan_area_' + a]).map(value => (
                    <Select.Option
                      key={value}
                      value={value}
                    >
                      {t['equality_plan_area_' + value]}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                hasFeedback
                validateStatus={ showError('female') ? 'error' : '' }
                help={ showError('female') }
                label={ t.equality_evaluation_of_results_beneficiaries_female }
                colon={false}
                required
              >
                <InputNumber
                  name="female"
                  value={ getValue('female') }
                  onChange={(value) => handleChange('female')(value)}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                hasFeedback
                validateStatus={ showError('male') ? 'error' : '' }
                help={ showError('male') }
                label={ t.equality_evaluation_of_results_beneficiaries_male }
                colon={false}
                required
              >
                <InputNumber
                  name="male"
                  value={ getValue('male') }
                  onChange={(value) => handleChange('male')(value)}
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
    </Modal>
  )
};

export default injectIntl(BeneficiariesByAreaForm);
